import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, IconButton, Tooltip } from '@material-ui/core';
import { toggleRightDrawer, invokePostService, invokeGetService, invokeFileDownloadService, handleSnackBar } from '../../../store/global/actions';
import UpdateCancel from "../../atoms/buttons/UpdateCancel";
import JsonTableEditor from '../../atoms/jsonFormEditor/JsonTableEditor';
import LoaderWithProgress from '../../atoms/loader/LoaderWithProgress';
import { convertArrayToSchema, generateSchema, cleanSchema } from '../../../config/database_schema';
import Alert from '@material-ui/lab/Alert';
import './style.css';
import { getReRender } from '../../../store/global/selectors';
import DeleteDatabaseSampleData from './DeleteDatabaseSampleData';
import GetAppIcon from '@material-ui/icons/GetApp';
import DeleteIcon from '@material-ui/icons/Delete';
import CircularProgress from '@material-ui/core/CircularProgress';

const options = {
  form_name_root: "delegate_profile",
  show_errors: "interaction",
  // disable_collapse: true,
  // disable_array_add: true,
  // disable_array_delete: true,
  // disable_array_reorder: true,
  // disable_properties: true,
  // no_additional_properties: false,
  // keep_oneof_values: false
}

export default function DelegateProfile({ element, onCompletion, loading, setLoading, setDatabaseProfileSchema }) {

  const dispatch = useDispatch();
  const [editorSchema, setEditorSchema] = useState({});
  const [schemaValues, setSchemaValues] = useState({});
  const [isUpdating, setIsUpdating] = useState(false);
  const [formData, setFormData] = useState({});
  const [showNoPlatformSchemaAlert, setShowNoPlatformSchemaAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [editorObj, setEditorObj] = useState(null);
  const [databaseSampleData, setDatabaseSampleData] = useState(null);
  const [openDeleteSampleDataAlert, setOpenDeleteSampleDataAlert] = useState(false);
  const [downloadProgress, setDownloadProgress] = useState(null);

  const reRender = useSelector(getReRender);

  useEffect(() => {
    loadDelegateSchema();
  }, [element, reRender])


  const loadDelegateSchema = () => {
    setLoading(true);
    Promise.all([
      dispatch(invokeGetService('getDelegateProfileSchema', [element.protocol])),
      dispatch(invokeGetService('getDatabaseProfileData', [element.id])),
    ]).then(([profileschema, profileSchemaData]) => {

      if (profileschema.status) {
        let refinedSchemaArray = profileschema.data.schema.filter(pf => pf.name !== "routes")
        let convertedSchema = convertArrayToSchema(refinedSchemaArray)

        setEditorSchema(convertedSchema);

        if (profileSchemaData.status && profileSchemaData.data && profileSchemaData.data.attributes) {
          setSchemaValues(generateSchema(refinedSchemaArray, profileSchemaData.data.attributes))
          setDatabaseSampleData(profileSchemaData.data.sampleData);
          if (setDatabaseProfileSchema && profileSchemaData.data.attributes.tables?.length > 0) {
            setDatabaseProfileSchema(profileSchemaData.data.attributes)
          } else {
            setDatabaseProfileSchema(false);
          }
        } else {
          setSchemaValues(generateSchema(refinedSchemaArray))
        }
        setLoading(false)
      } else {
        setAlertMessage(profileschema?.isPlatformSchemaExist ? "No delegate profiles present" : "No platform schema has been selected for the blueprint")
        setShowNoPlatformSchemaAlert(true);
        setLoading(false);
      }
    });

  }


  const validation = (schema, value, path) => {
    const errors = [];

    const normalizedPath = path.replace(/\[(\d+)\]/g, ".$1");

    const targets = [
      /^delegate_profile\.tables\.\d+\.name$/,
      /^delegate_profile\.tables\.\d+\.columns\.\d+\.cname$/,
      /^delegate_profile\.tables\.\d+\.columns\.\d+\.type$/,
    ];
    console.log("normalizedPath--", normalizedPath)
    const shouldValidate = targets.some((re) => re.test(normalizedPath));
    console.log("shouldValidate--", shouldValidate)
    if (!shouldValidate) {
      return errors;
    }

    if (value === "" || value === undefined || value === null) {
      errors.push({
        path,
        property: "format",
        message: `${schema.title ? schema.title : "Field"} is required`,
      });
    }

    return errors;
  };
  function parseJsonStrings(obj) {
    if (Array.isArray(obj)) {
      return obj.map(parseJsonStrings);
    } else if (obj !== null && typeof obj === "object") {
      const result = {};
      for (let key in obj) {
        result[key] = parseJsonStrings(obj[key]);
      }
      return result;
    } else if (typeof obj === "string") {
      obj = obj.trim();
      if ((obj.startsWith("{") && obj.endsWith("}")) || (obj.startsWith("[") && obj.endsWith("]"))) {
        try {
          return parseJsonStrings(JSON.parse(obj));
        } catch (e) {
          return obj;
        }
      }
      return obj;
    } else {
      return obj;
    }
  }

  const onChangeJsonEditor = (data, jsonEditor) => {
    setEditorObj(jsonEditor);
    // Select all buttons with the specified titles
    const buttonsToDelete = [
      'button[title="Delete Last Columns"]',
      'button[title="Delete Last Index Column"]',
      'button[title="Delete Last Index"]',
      'button[title="Delete Last Table"]',
      'button[title="Delete All"]'
    ];

    // Iterate through each selector, find matching buttons, and remove them
    buttonsToDelete.forEach(selector => {
      const buttons = document.querySelectorAll(selector);
      buttons.forEach(button => {
        if (button) button.remove();
      });
    });

    const ths = document.querySelectorAll("table thead th");
    if (ths) {
      ths.forEach(th => {
        const text = th.innerText.trim();
        const columns = { "PK": "Primary Key", "UQ": "Unique", "NN": "Not Null", "AI": "Auto Increment" }
        const tooltip = columns[text] ? columns[text] : text;
        th.setAttribute("title", tooltip);
      });
    }

    const checkBoxes = document.querySelectorAll("table input[type='checkbox']");
    if (checkBoxes) {
      checkBoxes.forEach(cb => {
        cb.style.marginTop = "12px";
      });
    }

    const addTableBtn = document.querySelector('.json-editor-btn-add[title="Add Table"]');
    // Select the Tables title container
    const tablesTitle = document.querySelector('div[data-schematype="array"][data-schemapath="delegate_profile.tables"] > .h3.card-title');

    // Move button inside title span
    if (addTableBtn && tablesTitle) {
      tablesTitle.appendChild(addTableBtn);
      tablesTitle.style.display = 'flex';
      tablesTitle.style.justifyContent = 'space-between';
      tablesTitle.style.alignItems = 'center';
      addTableBtn.style.marginLeft = '10px';
    }


    const parsedData = parseJsonStrings(data);
    setFormData(parsedData);
  }

  const onUpdateSchema = () => {
    const validationErrors = editorObj.validate();
    if (validationErrors.length > 0) {
      editorObj.showValidationErrors(validationErrors);
      return;
    }
    setIsUpdating(true);
    dispatch(invokePostService('createDatabaseProfileSchema', { profileData: cleanSchema(formData) }, [element.id])).then(response => {
      setIsUpdating(false);
      if (response.status == true) {
        setSchemaValues(response?.data?.attributes)
        onCompletion('Database Profile', 'edit');
      } else {
      }
    });

  }

  const cancelUpdation = () => {
    dispatch(toggleRightDrawer())
  }

  const handleDeleteSampleData = () => {
    setOpenDeleteSampleDataAlert(true);
  }

  const onDeleteSampleData = () => {
    setOpenDeleteSampleDataAlert(false);
    setDatabaseSampleData(null);
  }

  const handleDownloadSampleData = () => {
    try {
      setDownloadProgress(20);
      dispatch(invokeFileDownloadService('downloadSampleData', { delegateId: element.id }))
        .then(async response => {
          if (!response.ok) {
            const responseJson = await response.json();
            dispatch(handleSnackBar({ open: true, message: responseJson.message, severity: "error" }));
            throw new Error('Network response was not ok');
          }
          setDownloadProgress(50);
          return response.blob()
        })
        .then(blob => {
          // Create a URL for the downloaded file
          const url = URL.createObjectURL(blob);
          setDownloadProgress(80);
          // Trigger a download prompt
          const link = document.createElement('a');
          link.href = url;
          link.download = `${element.name || "database"}_sample_data.json`;
          document.body.appendChild(link);
          link.click();
          URL.revokeObjectURL(url);
          document.body.removeChild(link);

        })
        .catch(error => {
          console.error('Failed to download sample data', error);
        }).finally(() => {
          setDownloadProgress(null);
        });
    } catch (error) {
      console.error('Failed to download sample data', error);
      setDownloadProgress(null);

    }
  }


  return (
    <>
      {loading && <LoaderWithProgress size={20} isContent={true} styleRoot={{ marginTop: '35vh' }} />}
      {!loading && showNoPlatformSchemaAlert && (
        <Alert severity="warning">{alertMessage}</Alert>
      )}
      {!loading && !showNoPlatformSchemaAlert && databaseSampleData && (
        <Alert
          severity="info"
          action={
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Tooltip title="Download sample data">
                <IconButton size="small" color="inherit" disableRipple disableFocusRipple style={{ outline: 'none' }} onClick={handleDownloadSampleData}>
                  {downloadProgress !== null ? (
                    <CircularProgress size={16} variant="determinate" value={downloadProgress} />
                  ) : (
                    <GetAppIcon fontSize="small" />
                  )}
                </IconButton>
              </Tooltip>
              <Tooltip title="Delete sample data">
                <IconButton size="small" color="secondary" disableRipple disableFocusRipple style={{ outline: 'none' }} onClick={handleDeleteSampleData}>
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </div>
          }
          style={{ marginBottom: 16 }}
        >
          A sample database dataset already exists for this profile. Regenerating will replace the existing dataset.
        </Alert>
      )}

      {!loading && !showNoPlatformSchemaAlert && <>
        <JsonTableEditor options={options} schema={editorSchema} schemaValues={schemaValues} validation={validation} onChangeJsonEditor={onChangeJsonEditor} editorId={"delegateProfileForm"} />
      </>}
      {!loading && !showNoPlatformSchemaAlert && <Grid item xs={12} style={loading ? { display: "flex", justifyContent: "flex-end", marginBottom: 20, marginTop: "30vh" } : { display: "flex", justifyContent: "flex-end", marginTop: 30 }}>
        <UpdateCancel updateDisable={isUpdating || loading} content={isUpdating ? 'Updating..' : 'Update'} onUpdate={onUpdateSchema} onCancel={cancelUpdation} typesNotIn={['transaction', 'view', 'simulation']} />
      </Grid>}

      {
        openDeleteSampleDataAlert &&
        <DeleteDatabaseSampleData delegateId={element.id} onClose={() => setOpenDeleteSampleDataAlert(false)} onCompletion={onDeleteSampleData} />
      }


    </>
  )
}
